import { createFileRoute } from '@tanstack/react-router';

import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';
import Loading from '@/_pages/agreements/commission/loading';

export const Route = createFileRoute('/_private/agreements/_template/$id/commission')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Commissions',
    tabKey: 'agreement/commission',
  },
  pendingComponent: Loading,
});
